// Custom cow-head icon (lucide-react has no cow icon). Matches lucide's stroke style
// so it drops in anywhere a lucide icon is used: <CowIcon className="w-6 h-6" />.
export function CowIcon({ className = "", ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      width="24"
      height="24"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* horns */}
      <path d="M5 7C3.3 6.6 2.4 4.9 3 3.3c1.5-.2 3 .8 3.4 2.4" />
      <path d="M19 7c1.7-.4 2.6-2.1 2-3.7-1.5-.2-3 .8-3.4 2.4" />
      {/* ears */}
      <path d="M5.5 7.5C3.9 7.5 2.5 8.7 2.5 10.3c0 1.1.8 1.9 1.8 2" />
      <path d="M18.5 7.5c1.6 0 3 1.2 3 2.8 0 1.1-.8 1.9-1.8 2" />
      {/* head */}
      <path d="M5 9c0-1.9 1.2-3 3-3h8c1.8 0 3 1.1 3 3v2a7 7 0 0 1-7 7 7 7 0 0 1-7-7z" />
      {/* eyes */}
      <path d="M9 10.5h.01" />
      <path d="M15 10.5h.01" />
      {/* muzzle */}
      <path d="M8.5 14h7a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2 2 2 0 0 1 2-2z" />
      <path d="M10.5 16h.01" />
      <path d="M13.5 16h.01" />
    </svg>
  );
}
